/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdrAnimalDto } from '../../models/adr-animal-dto';

export interface GetAnimal$Params {
  id: string;
}

export function getAnimal(http: HttpClient, rootUrl: string, params: GetAnimal$Params, context?: HttpContext): Observable<StrictHttpResponse<AdrAnimalDto>> {
  const rb = new RequestBuilder(rootUrl, getAnimal.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AdrAnimalDto>;
    })
  );
}

getAnimal.PATH = '/api/animals/{id}';
